import React from 'react';
import { useInterview } from '../hooks/useInterview';
import styles from '../styles/Interview.module.css';
import { getFeedbackCopy } from '../utils/feedbackLocalization';

const RATING_FACES = ['😡', '😕', '😐', '🙂', '😍'] as const;

const RateExperience: React.FC = () => {
  const { session, handleRatingSubmit, updateSession, addMessage, analysis } = useInterview();
  const feedbackCopy = getFeedbackCopy(session.interviewLanguage);

  const onRatingClick = (rating: number) => {
    updateSession({ currentRating: rating });
    handleRatingSubmit(rating);

    // Now, check for and display the final analysis.
    if (analysis.content) {
      addMessage(analysis.content, 'ai', true);
    }
  };

  return (
    <>
      <div className={styles.faceRatingContainer} onMouseLeave={() => updateSession({ currentRating: session.currentRating || 0 })}>
        {RATING_FACES.map((face, index) => {
          const rating = index + 1;
          const label = feedbackCopy.ratingLabels[index];
          return (
            <button
              key={rating}
              type="button"
              translate="no"
              aria-label={label}
              aria-pressed={rating === session.currentRating}
              className={`${styles.faceRating} notranslate ${rating === session.currentRating ? styles.selected : ''}`}
              onClick={() => onRatingClick(rating)}
              onMouseEnter={() => updateSession({ currentRating: rating })}
            >
              {face}
            </button>
          );
        })}
      </div>
    </>
  );
};

export default RateExperience;
